import { DateTime } from 'luxon';
import { TranslationService } from '../../../../../../services/translation.service';
import { createWhenString } from '../../../../../Shared/TripLegSelector/components/helpers/summary-helpers';
import { DateTimeHelper } from '../../../../../../helpers/date-time.helper';

function Summary({
  id,
  departureStation,
  arrivalStation,
  departureTime,
  arrivalTime,
  onEditButtonClick,
}: {
  id: string;
  departureStation: string;
  arrivalStation: string;
  departureTime: DateTime;
  arrivalTime: DateTime;
  onEditButtonClick?: (() => void) | undefined;
}) {
  return (
    <div className="trip-leg-selector-summary p-2 rounded border">
      <table className="table table-borderless table-sm">
        <caption className="visually-hidden">{TranslationService.get('customerserviceforms.triplegselectorsummarycaption')}</caption>
        <tbody>
          <tr>
            <th scope="row">{TranslationService.get('common.from')}:</th>
            <td className="w-100">{departureStation}</td>
          </tr>
          <tr>
            <th scope="row">{TranslationService.get('common.to')}:</th>
            <td>{arrivalStation}</td>
          </tr>
          <tr>
            <th scope="row">{TranslationService.get('common.when')}:</th>
            <td>
              <span className="text-preserve-spaces">{createWhenString(departureTime, arrivalTime)}</span>
            </td>
          </tr>
          <tr>
            <th scope="row">{TranslationService.get('common.traveltime')}:</th>
            <td>{DateTimeHelper.toDuration(departureTime, arrivalTime)}</td>
          </tr>
        </tbody>
      </table>
      <div className="text-end">
        <button className="btn btn-tertiary btn-icon-left btn-icon-pen" aria-controls={`${id}-form`} onClick={onEditButtonClick}>
          {TranslationService.get('common.edit')}
        </button>
      </div>
    </div>
  );
}

export default Summary;
